import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { isCsvFile } from '../../../../constants/utils';

// Actions
import {
  checkCsv,
  submitUserConfirmation,
} from '../../../../actions/website/FileUploadActions';
import { fetchGuestList } from '../../../../actions/GuestActions';
import { clearUploadErrors, receiveUploadErrors, sendCsv, uploadComplete } from '../../../../actions/GuestImportActions';
import { hideModal } from '../../../../actions/ModalActions';

// Components
import { Tabs, Pane } from '../../ui/tabs';
import AddGuestGroupForm from './AddGuestGroupForm';
import UploadCSV from './UploadCSV';
import SendLink from './SendLink';
import ImportSuccess from './content/ImportSuccess';

// Styles
import './AddGuestGroupModal.less';

const TAB_NAME_TO_INDEX = {
  ENTER_INDIVIDUALLY: 0,
  SEND_LINK: 1,
  UPLOAD_SPREADSHEET: 2,
};

class AddGuestGroupModal extends Component {
  constructor(props) {
    super(props);
    this.startLoaderDelay = this.startLoaderDelay.bind(this);
    this.onFileSelect = this.onFileSelect.bind(this);
    this.state = {
      guestGroupTemplate: props.guestGroupType || 'SINGLE',
      showLoading: false
    };
  }

  componentDidUpdate(prevProps) {
    const { isUploading } = this.props;
    if (prevProps.isUploading === false && isUploading) {
      this.startLoaderDelay();
    }
  }

  onFileSelect(file) {
    const { onSendCsv, clearErrors, setErrors, flowRunId, updateFlowRunId } = this.props;
    return new Promise((resolve, reject) => {
      if (isCsvFile(file)) {
        clearErrors();
        onSendCsv(file, flowRunId, updateFlowRunId);
        return resolve();
      }
      setErrors(['Please upload a CSV file.'])
      return reject();
    })
  };

  startLoaderDelay() {
    this.setState({ showLoading: true });
    setTimeout(() => this.setState({ showLoading: false }), 2000);
  }

  render() {
    const {
      account,
      activeTab,
      beginMapping,
      callback,
      closeModal,
      isMappingReady,
      isUploading,
      prefilledGuestFormValues,
      sendLinkVisible,
      showUploadPane,
      uploadErrors,
      flowRunId,
    } = this.props;
    const showUpload = showUploadPane || true;
    const showLinkPane = sendLinkVisible;
    const { guestGroupTemplate, showLoading } = this.state;
    const showSuccess = isMappingReady && uploadErrors.length === 0 && !showLoading;
    const bodyClass = cx('modal__body', { 'no-nav': (!sendLinkVisible && !showUploadPane) });
    return (showSuccess) ? (
      <ImportSuccess onMappingStart={beginMapping} flowRunId={flowRunId}/>
    ) : (
      <div className="add-guest-group-modal">
        <div className="modal__header">
          <h3 className="modal__title">Add Guests</h3>
        </div>
        <div className={bodyClass}>
          <Tabs selected={TAB_NAME_TO_INDEX[activeTab] || 0}>
            <Pane label="Enter Individually">
              <AddGuestGroupForm template={guestGroupTemplate} callback={callback} prefilledGuestFormValues={prefilledGuestFormValues} />
            </Pane>
            {showLinkPane &&
              <Pane label="Send a Link">
                <SendLink hashId={account.hash_id} closeModal={closeModal} />
              </Pane>
            }
            {showUpload && (
              <Pane label="Upload a Spreadsheet">
                <UploadCSV
                  callback={callback}
                  onFileSelect={this.onFileSelect}
                  isUploading={showLoading || isUploading}
                  onMappingStart={beginMapping}
                  uploadErrors={uploadErrors}
                  flowRunId={flowRunId}
                />
              </Pane>
            )}

          </Tabs>
        </div>
      </div>
    );
  }
}

AddGuestGroupModal.propTypes = {
  sendLinkVisible: true,
  showUploadPane: true,
}

AddGuestGroupModal.propTypes = {
  account: PropTypes.shape({
    hash_id: PropTypes.string
  }),
  beginMapping: PropTypes.func,
  onSendCsv: PropTypes.func,
  closeModal: PropTypes.func,
  guestGroupType: PropTypes.string,
  callback: PropTypes.func,
  activeTab: PropTypes.string,
  sendLinkVisible: PropTypes.bool,
  showUploadPane: PropTypes.bool,
  prefilledGuestFormValues: PropTypes.arrayOf(
    PropTypes.shape({
      first_name: PropTypes.string,
      family_name: PropTypes.string,
    })
  ),
  flowRunId: PropTypes.string,
  updateFlowRunId: PropTypes.func,
};

const mapStateToProps = state => ({
  account: state.wedding.account,
  busy: state.modal.busy,
  guestsInGuestList: state.guestList.guests.orderedIds,
  isMappingReady: state.guestList.guestImport.readyToMap,
  isUploading: state.guestList.guestImport.busy,
  uploadErrors: state.guestList.guestImport.uploadErrors,
});

const mapDispatchToProps = dispatch => ({
  beginMapping: () => dispatch(uploadComplete()),
  onSendCsv: (file, flowRunId, updateFlowRunId) => dispatch(sendCsv(file, flowRunId, updateFlowRunId)),
  onFileCheck: (file, guestsInGuestList) => dispatch(checkCsv(file, guestsInGuestList)),
  handleUpload: () => dispatch(submitUserConfirmation()),
  closeModal: () => dispatch(hideModal()),
  setErrors: errors => dispatch(receiveUploadErrors(errors)),
  clearErrors: () => dispatch(clearUploadErrors()),
  updateGuestList: () => dispatch(fetchGuestList()),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddGuestGroupModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/AddGuestGroupModal.jsx